import Vue from 'vue';

Vue.component('watchlist-add-button', {
    data: function () {
        return {
            watchlist:[]
        }
    },
    methods: {
        add: function (pageId) {
            console.log(this.watchlist);
            let exdays = 30;
            let now = new Date()
            now.setTime(now.getTime() + (exdays*24*60*60*1000));
            let expires = "expires="+ now.toUTCString();
            let val = "";
            if (this.watchlist.includes(pageId)) {
                let i = this.watchlist.indexOf(pageId);
                this.watchlist.splice(i, 1);
            } else {
                this.watchlist.push(pageId);
            }
            if (this.watchlist.length > 0) {
                val = this.watchlist.join("-");
            }
            document.cookie = "RM_WL="+val+"; expires="+expires+"; path=/";
        },
        getCookie: function() {
            let split = document.cookie.split("; ");
            return split.find(c => c.startsWith("RM_WL"));
        },
        isInWatchList: function(pageId) {
            return this.watchlist.includes(pageId);
        },
        init: function() {
            let vm = this;
            let c = this.getCookie();
            if (c) {
                let split = c.split("=");
                if (split.length == 2) {
                    if (split[1].length > 0) {
                        split[1].split("-").forEach(function (it) {
                            vm.watchlist.push(it);
                        });
                    }
                }
            }
        }
    },
    mounted: function() {
        this.init();
    }
});